"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassesModule = void 0;
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@src/services/settings.service");
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = __importDefault(require("lodash"));
var api_wrapper_1 = require("../../../api/api-wrapper");
var classes_service_1 = require("./services/classes.service");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var Weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
var WeekdayLabels = {
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
};
var WeekdayShortLabels = {
    monday: 'Mo',
    tuesday: 'Di',
    wednesday: 'Mi',
    thursday: 'Do',
    friday: 'Fr',
    saturday: 'Sa',
    sunday: 'So',
};
var ClassesModule = /** @class */ (function () {
    function ClassesModule() {
        this.classes = [];
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.classesService = object_service_1.ObjectService.getInstance(classes_service_1.ClassesService);
        this.apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
        this.studios = [];
        this.selectedLocationIds = [];
        this.selectedCategories = [];
        this.selectedTrainerIds = [];
        this.selectedMobileWeekday = 'monday';
    }
    ClassesModule.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fittecId;
            var _a;
            return __generator(this, function (_b) {
                this.injectClassesStyles();
                fittecId = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.fittecId;
                if (!(fittecId === null || fittecId === void 0 ? void 0 : fittecId.length)) {
                    console.error('Classes module needs fittecId in settings');
                    return [2 /*return*/];
                }
                // make sure load module is not blocking
                void this.loadStudioFilters();
                void this.loadClasses();
                return [2 /*return*/];
            });
        });
    };
    ClassesModule.prototype.loadClasses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        (0, generator_const_1._CreateLoadingScreen)();
                        _a = this;
                        return [4 /*yield*/, this.classesService.getClasses({
                                fittecId: (_b = this.config.get.fittecId) !== null && _b !== void 0 ? _b : '-',
                                studioIds: this.getStudioIds(),
                                startDate: this.getStartDate(),
                                days: this.getDays(),
                            }, this.config)];
                    case 1:
                        _a.classes = _c.sent();
                        console.log('Loaded classes', this.classes);
                        this.renderClassFilterOptions();
                        this.renderClasses();
                        (0, generator_const_1._DeleteLoadingScreen)();
                        return [2 /*return*/];
                }
            });
        });
    };
    ClassesModule.prototype.getStudioIds = function () {
        return this.selectedStudioIds;
    };
    ClassesModule.prototype.getStartDate = function () {
        return getCurrentWeekStartDate();
    };
    ClassesModule.prototype.getDays = function () {
        return 6;
    };
    ClassesModule.prototype.loadStudioFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var refObject, _a, _i, _b, studio, checkboxClone, studioId, inputId, input;
            var _this = this;
            var _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        refObject = (_c = this.module.references) === null || _c === void 0 ? void 0 : _c.studioFilterCheckbox;
                        if (!((_d = refObject === null || refObject === void 0 ? void 0 : refObject.domElement) === null || _d === void 0 ? void 0 : _d.length) || !((_e = refObject === null || refObject === void 0 ? void 0 : refObject.parent) === null || _e === void 0 ? void 0 : _e.length)) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.apiWrapper.getStudios()];
                    case 1:
                        _a.studios = _g.sent();
                        this.selectedStudioIds = this.studios.map(function (studio) { return studio.id.toString(); });
                        (_f = refObject.removeClones) === null || _f === void 0 ? void 0 : _f.call(refObject);
                        for (_i = 0, _b = this.studios; _i < _b.length; _i++) {
                            studio = _b[_i];
                            checkboxClone = refObject.domElement.clone();
                            studioId = studio.id.toString();
                            inputId = "classes-studio-filter-".concat(studioId);
                            input = checkboxClone.find('input[type="checkbox"]').first();
                            checkboxClone.attr('data-clone', 'true');
                            checkboxClone.attr('data-clone-id', refObject.uid);
                            checkboxClone.removeAttr('id');
                            checkboxClone.removeAttr('data-ref');
                            input.attr('id', inputId);
                            input.attr('value', studioId);
                            input.prop('checked', true);
                            input.on('change', function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.selectedStudioIds = this.getSelectedStudioIds();
                                            return [4 /*yield*/, this.loadClasses()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                            checkboxClone.find('span, .w-form-label').first().text(studio.studioName);
                            checkboxClone.find('[for]').attr('for', inputId);
                            refObject.parent.append(checkboxClone);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ClassesModule.prototype.renderClassFilterOptions = function () {
        this.renderClassFilterCheckboxes('locationFilterCheckbox', getLocationFilterOptions(this.classes));
        this.renderClassFilterCheckboxes('categoryFilterCheckbox', getCategoryFilterOptions(this.classes));
        this.renderClassFilterCheckboxes('trainerFilterCheckbox', getTrainerFilterOptions(this.classes));
    };
    ClassesModule.prototype.renderClassFilterCheckboxes = function (referenceKey, options) {
        var _this = this;
        var _a, _b, _c, _d;
        var refObject = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a[referenceKey];
        if (!((_b = refObject === null || refObject === void 0 ? void 0 : refObject.domElement) === null || _b === void 0 ? void 0 : _b.length) || !((_c = refObject === null || refObject === void 0 ? void 0 : refObject.parent) === null || _c === void 0 ? void 0 : _c.length)) {
            return;
        }
        var previousSelectedValues = this.getSelectedClassFilterValues(referenceKey);
        (_d = refObject.removeClones) === null || _d === void 0 ? void 0 : _d.call(refObject);
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var option = options_1[_i];
            var checkboxClone = refObject.domElement.clone();
            var inputId = getFilterInputId(referenceKey, option.id);
            var input = checkboxClone.find('input[type="checkbox"]').first();
            checkboxClone.attr('data-clone', 'true');
            checkboxClone.attr('data-clone-id', refObject.uid);
            checkboxClone.removeAttr('id');
            checkboxClone.removeAttr('data-ref');
            input.attr('id', inputId);
            input.attr('value', option.id);
            input.prop('checked', previousSelectedValues.includes(option.id));
            input.on('change', function () {
                _this.updateSelectedFrontendFilters();
                _this.renderClasses();
            });
            checkboxClone.find('span, .w-form-label').first().text(option.label);
            checkboxClone.find('[for]').attr('for', inputId);
            refObject.parent.append(checkboxClone);
        }
        this.updateSelectedFrontendFilters();
    };
    ClassesModule.prototype.updateSelectedFrontendFilters = function () {
        this.selectedLocationIds = this.getSelectedClassFilterValues('locationFilterCheckbox');
        this.selectedCategories = this.getSelectedClassFilterValues('categoryFilterCheckbox');
        this.selectedTrainerIds = this.getSelectedClassFilterValues('trainerFilterCheckbox');
    };
    ClassesModule.prototype.getSelectedClassFilterValues = function (referenceKey) {
        var _a, _b;
        var refObject = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a[referenceKey];
        if (!((_b = refObject === null || refObject === void 0 ? void 0 : refObject.parent) === null || _b === void 0 ? void 0 : _b.length)) {
            return [];
        }
        return refObject.parent
            .find("[data-clone=\"true\"][data-clone-id=\"".concat(refObject.uid, "\"] input[type=\"checkbox\"]:checked"))
            .get()
            .map(function (input) { return String(input.value); })
            .filter(function (value) { return value.length; });
    };
    ClassesModule.prototype.getSelectedStudioIds = function () {
        var _a, _b;
        var refObject = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.studioFilterCheckbox;
        if (!((_b = refObject === null || refObject === void 0 ? void 0 : refObject.parent) === null || _b === void 0 ? void 0 : _b.length)) {
            return [];
        }
        return refObject.parent
            .find("[data-clone=\"true\"][data-clone-id=\"".concat(refObject.uid, "\"] input[type=\"checkbox\"]:checked"))
            .get()
            .map(function (input) { return String(input.value); })
            .filter(function (studioId) { return studioId.length; });
    };
    ClassesModule.prototype.renderClasses = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var classesByWeekday = this.getClassesByWeekday(this.getFilteredClasses());
        var weekdayData = this.getWeekdayRenderData();
        var containerRef = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.classesContainer;
        var headerDefaultRef = (_b = this.module.references) === null || _b === void 0 ? void 0 : _b.classesHeaderDefault;
        var entryDefaultRef = (_c = this.module.references) === null || _c === void 0 ? void 0 : _c.classesEntryDefault;
        var mobileNavButtonRef = (_d = this.module.references) === null || _d === void 0 ? void 0 : _d.mobileNavButton;
        var mobileNavButtonActiveRef = (_e = this.module.references) === null || _e === void 0 ? void 0 : _e.mobileNavButtonActive;
        if (!((_f = containerRef === null || containerRef === void 0 ? void 0 : containerRef.domElement) === null || _f === void 0 ? void 0 : _f.length) ||
            !((_g = headerDefaultRef === null || headerDefaultRef === void 0 ? void 0 : headerDefaultRef.domElement) === null || _g === void 0 ? void 0 : _g.length) ||
            !((_h = entryDefaultRef === null || entryDefaultRef === void 0 ? void 0 : entryDefaultRef.domElement) === null || _h === void 0 ? void 0 : _h.length) ||
            !((_j = mobileNavButtonRef === null || mobileNavButtonRef === void 0 ? void 0 : mobileNavButtonRef.domElement) === null || _j === void 0 ? void 0 : _j.length) ||
            !((_k = mobileNavButtonActiveRef === null || mobileNavButtonActiveRef === void 0 ? void 0 : mobileNavButtonActiveRef.domElement) === null || _k === void 0 ? void 0 : _k.length)) {
            console.error('Classes module needs classes-container, classes-header-default, classes-entry-default, mobile-nav-button and mobile-nav-button-active references');
            return;
        }
        this.prepareClassesContainer(containerRef.domElement);
        this.renderMobileDayNavigation(containerRef.domElement, weekdayData);
        var grid = (0, cash_dom_1.default)('<div></div>').addClass('fittec-classes-grid');
        for (var _i = 0, weekdayData_1 = weekdayData; _i < weekdayData_1.length; _i++) {
            var weekday = weekdayData_1[_i];
            var weekdayColumn = this.createWeekdayColumn(weekday);
            if (weekday.weekday === this.selectedMobileWeekday) {
                weekdayColumn.addClass('fittec-classes-weekday-column-active');
            }
            var headerRef = this.getHeaderReference(weekday.isToday);
            var headerClone = this.cloneReference(headerRef);
            if (headerClone === null || headerClone === void 0 ? void 0 : headerClone.length) {
                headerClone.attr('data-weekday', weekday.weekday);
                headerClone.attr('data-date', weekday.dateIso);
                this.replaceHeaderPlaceholders(headerClone, weekday);
                weekdayColumn.append(headerClone);
            }
            var dayEntriesContainer = this.createDayEntriesContainer(weekday);
            var entryRef = this.getEntryReference(weekday.isToday);
            var classSlots = classesByWeekday[weekday.weekday];
            for (var _q = 0, classSlots_1 = classSlots; _q < classSlots_1.length; _q++) {
                var classSlot = classSlots_1[_q];
                var classClone = this.cloneReference(entryRef);
                if (!(classClone === null || classClone === void 0 ? void 0 : classClone.length)) {
                    continue;
                }
                classClone
                    .addClass('class-id-' + ((_m = (_l = classSlot.classInformation) === null || _l === void 0 ? void 0 : _l.id) !== null && _m !== void 0 ? _m : 'none'))
                    .attr('data-class-id', (_p = (_o = classSlot.classInformation) === null || _o === void 0 ? void 0 : _o.id) !== null && _p !== void 0 ? _p : 'none')
                    .attr('data-i18n-ignore', 'true')
                    .attr('translate', 'no');
                this.replaceDataGetPlaceholders(classClone, classSlot);
                dayEntriesContainer.append(classClone);
            }
            weekdayColumn.append(dayEntriesContainer);
            grid.append(weekdayColumn);
        }
        containerRef.domElement.append(grid);
    };
    ClassesModule.prototype.prepareClassesContainer = function (container) {
        container.empty();
        container.removeClass('fittec-classes-grid');
        container.addClass('fittec-classes-container');
    };
    ClassesModule.prototype.createWeekdayColumn = function (weekday) {
        return (0, cash_dom_1.default)('<div></div>')
            .addClass('fittec-classes-weekday-column')
            .attr('data-weekday', weekday.weekday)
            .attr('data-date', weekday.dateIso);
    };
    ClassesModule.prototype.createDayEntriesContainer = function (weekday) {
        var dayEntriesContainer = (0, cash_dom_1.default)('<div></div>')
            .addClass('fittec-classes-day-entries')
            .attr('data-weekday', weekday.weekday)
            .attr('data-date', weekday.dateIso);
        dayEntriesContainer.addClass('fittec-classes-active-day');
        return dayEntriesContainer;
    };
    ClassesModule.prototype.renderMobileDayNavigation = function (container, weekdayData) {
        var _this = this;
        var nav = (0, cash_dom_1.default)('<div></div>').addClass('fittec-classes-mobile-day-nav');
        var _loop_1 = function (weekday) {
            var buttonRef = this_1.getMobileNavButtonReference(weekday.weekday === this_1.selectedMobileWeekday);
            var buttonClone = this_1.cloneReference(buttonRef);
            if (!(buttonClone === null || buttonClone === void 0 ? void 0 : buttonClone.length)) {
                return "continue";
            }
            buttonClone
                .addClass('fittec-classes-mobile-day-button')
                .attr('role', 'button')
                .attr('tabindex', '0')
                .attr('data-weekday', weekday.weekday)
                .attr('data-date', weekday.dateIso);
            if (weekday.weekday === this_1.selectedMobileWeekday) {
                buttonClone.addClass('fittec-classes-mobile-day-button-active');
            }
            this_1.replaceHeaderPlaceholders(buttonClone, weekday);
            buttonClone.on('click', function () {
                _this.selectedMobileWeekday = weekday.weekday;
                _this.renderClasses();
            });
            buttonClone.on('keydown', function (event) {
                if (event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }
                event.preventDefault();
                _this.selectedMobileWeekday = weekday.weekday;
                _this.renderClasses();
            });
            nav.append(buttonClone);
        };
        var this_1 = this;
        for (var _i = 0, weekdayData_2 = weekdayData; _i < weekdayData_2.length; _i++) {
            var weekday = weekdayData_2[_i];
            _loop_1(weekday);
        }
        container.append(nav);
    };
    ClassesModule.prototype.getHeaderReference = function (isToday) {
        var _a, _b, _c;
        var todayRef = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.classesHeaderToday;
        if (isToday && ((_b = todayRef === null || todayRef === void 0 ? void 0 : todayRef.domElement) === null || _b === void 0 ? void 0 : _b.length)) {
            return todayRef;
        }
        return (_c = this.module.references) === null || _c === void 0 ? void 0 : _c.classesHeaderDefault;
    };
    ClassesModule.prototype.getEntryReference = function (isToday) {
        var _a, _b, _c;
        var todayRef = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.classesEntryToday;
        if (isToday && ((_b = todayRef === null || todayRef === void 0 ? void 0 : todayRef.domElement) === null || _b === void 0 ? void 0 : _b.length)) {
            return todayRef;
        }
        return (_c = this.module.references) === null || _c === void 0 ? void 0 : _c.classesEntryDefault;
    };
    ClassesModule.prototype.getMobileNavButtonReference = function (isActive) {
        var _a, _b, _c;
        var activeRef = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.mobileNavButtonActive;
        if (isActive && ((_b = activeRef === null || activeRef === void 0 ? void 0 : activeRef.domElement) === null || _b === void 0 ? void 0 : _b.length)) {
            return activeRef;
        }
        return (_c = this.module.references) === null || _c === void 0 ? void 0 : _c.mobileNavButton;
    };
    ClassesModule.prototype.cloneReference = function (refObject) {
        var _a, _b, _c;
        if (!((_a = refObject === null || refObject === void 0 ? void 0 : refObject.domElement) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        var clone = (_c = (_b = refObject.cloneDomElement) === null || _b === void 0 ? void 0 : _b.call(refObject)) !== null && _c !== void 0 ? _c : refObject.domElement.clone();
        clone.attr('data-clone', 'true');
        clone.attr('data-clone-id', refObject.uid);
        clone.removeAttr('id');
        clone.removeAttr('data-ref');
        return clone;
    };
    ClassesModule.prototype.getWeekdayRenderData = function () {
        var weekStart = parseLocalDate(this.getStartDate());
        var today = new Date();
        return Weekdays.map(function (weekday, index) {
            var date = new Date(weekStart);
            date.setDate(weekStart.getDate() + index);
            return {
                weekday: weekday,
                weekdayLabel: WeekdayLabels[weekday],
                weekdayShortLabel: WeekdayShortLabels[weekday],
                date: date,
                dateIso: getLocalDateString(date),
                isToday: isSameLocalDate(date, today),
            };
        });
    };
    ClassesModule.prototype.getFilteredClasses = function () {
        var _this = this;
        return this.classes.filter(function (classSlot) {
            var _a, _b, _c;
            var matchesLocation = _this.selectedLocationIds.length === 0 ||
                (((_a = classSlot.location) === null || _a === void 0 ? void 0 : _a.id) !== undefined && _this.selectedLocationIds.includes(classSlot.location.id));
            var matchesCategory = _this.selectedCategories.length === 0 ||
                (((_b = classSlot.classInformation) === null || _b === void 0 ? void 0 : _b.category) !== undefined &&
                    _this.selectedCategories.includes(classSlot.classInformation.category));
            var matchesTrainer = _this.selectedTrainerIds.length === 0 ||
                ((_c = classSlot.instructors) === null || _c === void 0 ? void 0 : _c.some(function (instructor) { return _this.selectedTrainerIds.includes(instructor.id); }));
            return matchesLocation && matchesCategory && matchesTrainer;
        });
    };
    ClassesModule.prototype.getClassesByWeekday = function (classes) {
        var classesByWeekday = {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
            saturday: [],
            sunday: [],
        };
        var sortedClasses = __spreadArray([], classes, true).sort(function (a, b) {
            return getTimestamp(a.startDateTime) - getTimestamp(b.startDateTime);
        });
        for (var _i = 0, sortedClasses_1 = sortedClasses; _i < sortedClasses_1.length; _i++) {
            var classSlot = sortedClasses_1[_i];
            var weekday = getWeekday(classSlot.startDateTime);
            if (weekday) {
                classesByWeekday[weekday].push(classSlot);
            }
        }
        console.log('classes by weekday', classesByWeekday);
        return classesByWeekday;
    };
    ClassesModule.prototype.replaceDataGetPlaceholders = function (classClone, classSlot) {
        this.replacePlaceholders(classClone, function (attribute) { return getClassSlotValue(classSlot, attribute); });
    };
    ClassesModule.prototype.replaceHeaderPlaceholders = function (headerClone, weekday) {
        this.replacePlaceholders(headerClone, function (attribute) { return getWeekdayValue(weekday, attribute); });
    };
    ClassesModule.prototype.replacePlaceholders = function (element, getValue) {
        var cloneElement = element.get(0);
        if (!cloneElement)
            return;
        var placeholders = Array.prototype.slice.call(cloneElement.querySelectorAll('[data-get]'));
        if (cloneElement.hasAttribute('data-get')) {
            placeholders.push(cloneElement);
        }
        for (var _i = 0, placeholders_1 = placeholders; _i < placeholders_1.length; _i++) {
            var placeholder = placeholders_1[_i];
            var attribute = placeholder.getAttribute('data-get');
            if (!(attribute === null || attribute === void 0 ? void 0 : attribute.length)) {
                continue;
            }
            var value = getValue(attribute);
            placeholder.textContent = value === undefined || value === null ? '' : String(value);
            placeholder.removeAttribute('data-get');
        }
    };
    ClassesModule.prototype.injectClassesStyles = function () {
        var styleId = 'fittec-classes-module-styles';
        var existingStyle = document.getElementById(styleId);
        var css = "\n      .fittec-classes-container {\n        width: 100%;\n      }\n\n      .fittec-classes-grid {\n        display: grid;\n        grid-template-columns: repeat(7, minmax(0, 1fr));\n        column-gap: 12px;\n        row-gap: 24px;\n        width: 100%;\n      }\n\n      .fittec-classes-weekday-column {\n        min-width: 0;\n      }\n\n      .fittec-classes-day-entries {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        min-width: 0;\n      }\n\n      .fittec-classes-day-entries > * {\n        width: 100%;\n        max-width: 100%;\n        min-width: 0 !important;\n        box-sizing: border-box;\n      }\n\n      .fittec-classes-mobile-day-nav {\n        display: none;\n      }\n\n      @media (max-width: 767px) {\n        .fittec-classes-mobile-day-nav {\n          display: flex;\n          gap: 12px;\n          margin-bottom: 16px;\n          overflow-x: auto;\n          -webkit-overflow-scrolling: touch;\n        }\n\n        .fittec-classes-mobile-day-button {\n          cursor: pointer;\n          white-space: nowrap;\n          flex: 0 0 auto;\n        }\n\n        .fittec-classes-grid {\n          grid-template-columns: 1fr;\n        }\n\n        .fittec-classes-weekday-column {\n          display: none;\n        }\n\n        .fittec-classes-weekday-column-active {\n          display: block;\n        }\n\n        .fittec-classes-weekday-column-active > [data-clone=\"true\"][data-weekday] {\n          display: none;\n        }\n      }\n    ";
        if (existingStyle) {
            existingStyle.textContent = css;
            return;
        }
        var style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        document.head.appendChild(style);
    };
    return ClassesModule;
}());
exports.ClassesModule = ClassesModule;
function getCurrentWeekStartDate() {
    var date = new Date();
    var day = date.getDay();
    var daysSinceMonday = day === 0 ? 6 : day - 1;
    date.setDate(date.getDate() - daysSinceMonday);
    return getLocalDateString(date);
}
function getLocalDateString(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day);
}
function parseLocalDate(dateString) {
    var _a = dateString.split('-').map(Number), year = _a[0], month = _a[1], day = _a[2];
    return new Date(year, month - 1, day);
}
function isSameLocalDate(date, compareDate) {
    return getLocalDateString(date) === getLocalDateString(compareDate);
}
function getWeekday(dateTime) {
    if (dateTime === undefined) {
        return;
    }
    var date = new Date(dateTime);
    if (Number.isNaN(date.getTime())) {
        return;
    }
    var weekdayByDayNumber = {
        0: 'sunday',
        1: 'monday',
        2: 'tuesday',
        3: 'wednesday',
        4: 'thursday',
        5: 'friday',
        6: 'saturday',
    };
    return weekdayByDayNumber[date.getDay()];
}
function getTimestamp(dateTime) {
    if (dateTime === undefined) {
        return 0;
    }
    return Number.isNaN(dateTime) ? 0 : dateTime;
}
function getClassSlotValue(classSlot, attribute) {
    var _a, _b, _c, _d, _e;
    if (attribute === 'name' || attribute === 'title') {
        return (_a = classSlot.classInformation) === null || _a === void 0 ? void 0 : _a.title;
    }
    if (attribute === 'description') {
        return (_b = classSlot.classInformation) === null || _b === void 0 ? void 0 : _b.description;
    }
    if (attribute === 'category') {
        return (_c = classSlot.classInformation) === null || _c === void 0 ? void 0 : _c.category;
    }
    if (attribute === 'duration') {
        return (_d = classSlot.classInformation) === null || _d === void 0 ? void 0 : _d.duration;
    }
    if (attribute === 'startTime') {
        return formatTime(classSlot.startDateTime);
    }
    if (attribute === 'endTime') {
        return formatTime(classSlot.endDateTime);
    }
    if (attribute === 'date') {
        return formatDate(classSlot.startDateTime);
    }
    if (attribute === 'location') {
        return (_e = classSlot.location) === null || _e === void 0 ? void 0 : _e.name;
    }
    if (attribute === 'instructors') {
        return formatInstructors(classSlot);
    }
    return lodash_1.default.get(classSlot, attribute);
}
function getWeekdayValue(weekday, attribute) {
    if (attribute === 'weekday' || attribute === 'day' || attribute === 'title' || attribute === 'name') {
        return weekday.weekdayLabel;
    }
    if (attribute === 'weekdayShort' || attribute === 'dayShort') {
        return weekday.weekdayShortLabel;
    }
    if (attribute === 'date') {
        return weekday.date.toLocaleDateString('de-DE');
    }
    if (attribute === 'dateIso') {
        return weekday.dateIso;
    }
    if (attribute === 'isToday') {
        return weekday.isToday;
    }
    return lodash_1.default.get(weekday, attribute);
}
function getLocationFilterOptions(classes) {
    return getUniqueFilterOptions(classes
        .map(function (classSlot) {
        var _a, _b;
        return ((_a = classSlot.location) === null || _a === void 0 ? void 0 : _a.id) && ((_b = classSlot.location) === null || _b === void 0 ? void 0 : _b.name)
            ? {
                id: classSlot.location.id,
                label: classSlot.location.name,
            }
            : undefined;
    })
        .filter(Boolean));
}
function getCategoryFilterOptions(classes) {
    return getUniqueFilterOptions(classes
        .map(function (classSlot) {
        var _a;
        return ((_a = classSlot.classInformation) === null || _a === void 0 ? void 0 : _a.category)
            ? {
                id: classSlot.classInformation.category,
                label: classSlot.classInformation.category,
            }
            : undefined;
    })
        .filter(Boolean));
}
function getTrainerFilterOptions(classes) {
    return getUniqueFilterOptions(classes
        .flatMap(function (classSlot) { var _a; return (_a = classSlot.instructors) !== null && _a !== void 0 ? _a : []; })
        .map(function (instructor) { return ({
        id: instructor.id,
        label: instructor.publicName || "".concat(instructor.firstName, " ").concat(instructor.lastName).trim(),
    }); })
        .filter(function (option) { return option.id.length && option.label.length; }));
}
function getUniqueFilterOptions(options) {
    return Object.values(options.reduce(function (uniqueOptions, option) {
        uniqueOptions[option.id] = option;
        return uniqueOptions;
    }, {})).sort(function (a, b) { return a.label.localeCompare(b.label); });
}
function getFilterInputId(referenceKey, optionId) {
    return "classes-".concat(referenceKey, "-").concat(optionId.replace(/[^a-z0-9_-]/gi, '-'));
}
function formatTime(dateTime) {
    if (dateTime === undefined) {
        return '';
    }
    var date = new Date(dateTime);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    return date.toLocaleTimeString('de-DE', {
        hour: '2-digit',
        minute: '2-digit',
    });
}
function formatDate(dateTime) {
    if (dateTime === undefined) {
        return '';
    }
    var date = new Date(dateTime);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    return date.toLocaleDateString('de-DE');
}
function formatInstructors(classSlot) {
    var _a, _b;
    return ((_b = (_a = classSlot.instructors) === null || _a === void 0 ? void 0 : _a.map(function (instructor) { return instructor.publicName || "".concat(instructor.firstName, " ").concat(instructor.lastName).trim(); }).filter(function (name) { return name.length; }).join(', ')) !== null && _b !== void 0 ? _b : '');
}
